import { AddIcon, ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Fade,
  Flex,
  HStack,
  Image,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useDisclosure,
  useToast,
  VStack
} from '@chakra-ui/react';
import exportFromJSON from 'export-from-json';
import { useEffect, useRef, useState } from 'react';
import { HiPlusCircle } from 'react-icons/hi';
import { Column } from 'react-table';
import MaskedInput from 'react-text-mask';
import { v4 as uuid } from 'uuid';

import { BarCodeIcon } from '../../../assets/icons/BarCodeIcon';
import { BillIcon } from '../../../assets/icons/BillIcon';
import { ClockIcon } from '../../../assets/icons/ClockIcon';
import { WarningIcon } from '../../../assets/icons/WarningIcon';
import { InteractiveTable } from '../../../components/data/InteractiveTable';
import {
  getNumericEnumValuesAsArray,
  MetodoPagamentoEnum,
  ProdutosVidaEnum
} from '../../../enums';
import { apiSensedia } from '../../../services/api-sensedia';
import { delay } from '../../../utils/delay';
import { cpf } from '../../../utils/masks';

const createDateFromString = (dateString: string) => {
  const [day, month, year] = dateString.split('/').map(Number);

  const jsMonth = month - 1;

  return new Date(year, jsMonth, day);
};

function formatDate(dateString: string): string {
  if (dateString) {
    const [year, month, day] = dateString.split('-');

    return `${day}/${month}/${year}`;
  }
  return dateString;
}

type Table = {
  NOME: string;
  CPF: string;
  APOLICE: string;
  ID_CONTRATO: number;
  NUM_PROPOSTA: number;
  PRODUTO: string;
  EV: string;
  INICIO_VIGENCIA: string;
  MEIO_PAGAMENTO_ID: number;
  CODIGO_PRODUTO: number;
  EMISSAO: string;
  FIM_VIGENCIA: string;
  PREMIO: string;
  STATUS: string;
};

type Data = {
  table: Table[];
};

type Cobertura = {
  COBERTURA: string;
  VALOR_PREMIO: string;
  CAPITAL_CONTRATADO: string;
};

type Assistencia = {
  ASSISTENCIA: string;
  VALOR_PREMIO: string;
  CAPITAL_CONTRATADO: string;
};

type Details = {
  name: string;
  policy: string;
  cobertura: Cobertura[];
  assistencia: Assistencia[];
};

type BlockedFieldsType = {
  nome: boolean;
  cpf: boolean;
  produto: boolean;
  situacao: boolean;
  ev: boolean;
};

type HandleDetails = {
  row: {
    original: {
      APOLICE: number;
      CPF: string;
      EV: string;
      FIM_VIGENCIA: string;
      INICIO_VIGENCIA: string;
      MEIO_PAGAMENTO_ID: number;
      CODIGO_PRODUTO: number;
      NOME: string;
      ID_CONTRATO: number;
      NUM_PROPOSTA: number;
      PREMIO: number;
      PRODUTO: string;
      STATUS: string;
      EMISSAO: string;
    };
  };
};

export const CarteiraVida = (): JSX.Element => {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2
  } = useDisclosure();

  const {
    isOpen: isModalSegundaViaOpen,
    onOpen: onModalSegundaViaOpen,
    onClose: onModalSegundaViaClose
  } = useDisclosure();

  const [loading, setLoading] = useState(false);
  const [loadingSegundaVia, setLoadingSegundaVia] = useState({});
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const [data, setData] = useState<Data>({
    table: [
      {
        NOME: '',
        CPF: '',
        APOLICE: '',
        NUM_PROPOSTA: 0,
        ID_CONTRATO: 0,
        PRODUTO: '',
        EV: '',
        INICIO_VIGENCIA: '',
        EMISSAO: '',
        FIM_VIGENCIA: '',
        PREMIO: '',
        STATUS: '',
        MEIO_PAGAMENTO_ID: 0,
        CODIGO_PRODUTO: 0
      }
    ]
  });

  const [table, setTable] = useState<Table[]>([
    {
      NOME: '',
      CPF: '',
      APOLICE: '',
      PRODUTO: '',
      ID_CONTRATO: 0,
      NUM_PROPOSTA: 0,
      EV: '',
      EMISSAO: '',
      INICIO_VIGENCIA: '',
      FIM_VIGENCIA: '',
      PREMIO: '',
      STATUS: '',
      CODIGO_PRODUTO: 0,
      MEIO_PAGAMENTO_ID: 0
    }
  ]);

  const [modalSegundaViaContent, setModalSegundaViaContent] = useState<{
    num_proposta: number;
    nome_produto: string;
    codigo_produto: number;
    qr_code_url?: string;
    codigo_pix?: string;
    valor?: string;
    data_vencimento?: string;
    codigo_barras_formatado?: string;
  }>({
    num_proposta: 0,
    nome_produto: '',
    codigo_produto: 0,
    qr_code_url: '',
    codigo_pix: '',
    data_vencimento: '',
    codigo_barras_formatado: ''
  });

  const [details, setDetails] = useState<Details>({
    name: '',
    policy: '',
    cobertura: [
      {
        COBERTURA: '',
        VALOR_PREMIO: '',
        CAPITAL_CONTRATADO: ''
      }
    ],
    assistencia: [
      {
        ASSISTENCIA: '',
        VALOR_PREMIO: '',
        CAPITAL_CONTRATADO: ''
      }
    ]
  });

  const [itemsCount, setItemsCount] = useState(
    table.length > 10 ? 10 : table.length
  );
  const [itemsToShow, setItemsToShow] = useState(5);

  const [nameFilter, setNameFilter] = useState('');
  const [cpfFilter, setCpfFilter] = useState('');
  const [productFilter, setProductFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [evFilter, setEvFilter] = useState('');
  const [evOptions, setEvOptions] = useState([]);

  const blockedFieldsInitialValue = {
    cpf: false,
    ev: false,
    nome: false,
    produto: false,
    situacao: false
  };

  const [blockedFields, setBlockedFields] = useState<BlockedFieldsType>(
    blockedFieldsInitialValue
  );

  const fieldsRefs = {
    cpf: useRef<React.Component & { inputElement: HTMLInputElement }>(null),
    ev: useRef<HTMLSelectElement>(null),
    nome: useRef<HTMLInputElement>(null),
    produto: useRef<HTMLInputElement>(null),
    situacao: useRef<HTMLSelectElement>(null)
  };

  const resetBlockedValues = () => {
    setBlockedFields(blockedFieldsInitialValue);
  };

  const columns: Column<object>[] = [
    {
      Header: '',
      accessor: 'DETAILS',
      Cell: ({ row }: HandleDetails) => (
        <>
          {row.original.CPF && row.original.APOLICE ? (
            <Tooltip label="Detalhes">
              <Button
                as={AddIcon}
                cursor="pointer"
                variant="ghost"
                w="2.8rem"
                onClick={() =>
                  handleDetails(
                    row.original.NOME,
                    row.original.CPF,
                    row.original.APOLICE?.toString()
                  )
                }
              />
            </Tooltip>
          ) : null}
        </>
      )
    },
    {
      Header: (
        <>
          2ª Via da{' '}
          <Box as="span" whiteSpace="nowrap">
            1ª parcela
          </Box>
        </>
      ),
      accessor: 'SEGUNDA_VIA',
      Cell: ({ row }: HandleDetails) => {
        const dataEmissao = createDateFromString(row.original.EMISSAO);
        const now = new Date();

        const diffInMillis = now.getTime() - dataEmissao.getTime();

        const diffInDays = diffInMillis / (1000 * 60 * 60 * 24);

        const meiosPagamento = getNumericEnumValuesAsArray(MetodoPagamentoEnum);

        const codigosProdutos = getNumericEnumValuesAsArray(ProdutosVidaEnum);

        const secondCopyEnabled =
          row.original.STATUS !== 'Recusada' &&
          row.original.STATUS !== 'Cancelada' &&
          row.original.STATUS !== 'Em digitacão' &&
          diffInDays <= 30 &&
          meiosPagamento.includes(row.original.MEIO_PAGAMENTO_ID) &&
          codigosProdutos.includes(row.original.CODIGO_PRODUTO);
        return (
          <Tooltip label={secondCopyEnabled ? 'Emitir segunda via' : undefined}>
            <Box
              cursor={secondCopyEnabled ? 'pointer' : 'not-allowed'}
              pointerEvents={secondCopyEnabled ? 'all' : 'none'}
              width="100%"
              display="flex"
              justifyContent="center"
              onClick={async () => {
                setLoadingSegundaVia({ [row.original.ID_CONTRATO]: true });
                try {
                  const dadosSegundaVia = await getDadosSegundaVia({
                    id_contrato: row.original.ID_CONTRATO,
                    num_proposta: row.original.NUM_PROPOSTA
                  });

                  console.log({ dadosSegundaVia });

                  setModalSegundaViaContent({
                    num_proposta: row.original.NUM_PROPOSTA,
                    nome_produto: row.original.PRODUTO,
                    codigo_produto: row.original.CODIGO_PRODUTO,
                    codigo_pix: dadosSegundaVia.codigo_qr_code,
                    qr_code_url: dadosSegundaVia.link_qr_code,
                    data_vencimento: dadosSegundaVia.data_vencimento,
                    codigo_barras_formatado:
                      dadosSegundaVia.codigo_barras_formatado,
                    valor: dadosSegundaVia.valor
                  });

                  if (secondCopyEnabled) {
                    onModalSegundaViaOpen();
                  }
                } catch (e: any) {
                  const errorData = e?.response?.data;

                  toast({
                    position: 'top',
                    description: (
                      <Box>
                        <Text fontWeight="bold" marginBottom="15px">
                          {errorData?.message}
                        </Text>
                        <VStack>
                          {errorData?.errors_list?.map((error: string) => (
                            <Text margin="0" key={uuid()}>
                              {error}
                            </Text>
                          ))}
                        </VStack>
                      </Box>
                    ),
                    duration: 3000,
                    isClosable: true,
                    status: 'error'
                  });
                }

                setLoadingSegundaVia({ [row.original.ID_CONTRATO]: false });
              }}
            >
              {loadingSegundaVia[row.original.ID_CONTRATO] ? (
                <Spinner />
              ) : (
                <BillIcon
                  width={27}
                  color={secondCopyEnabled ? '#00335E' : '#BCC2CE'}
                />
              )}
            </Box>
          </Tooltip>
        );
      }
    },
    {
      Header: 'Nome',
      accessor: 'NOME'
    },
    {
      Header: 'CPF',
      accessor: 'CPF'
    },
    {
      Header: 'Apólice',
      accessor: 'APOLICE'
    },
    {
      Header: 'Proposta',
      accessor: 'NUM_PROPOSTA'
    },
    {
      Header: 'Produto',
      accessor: 'PRODUTO'
    },
    {
      Header: 'EV',
      accessor: 'EV'
    },
    {
      Header: 'Início vigência',
      accessor: 'INICIO_VIGENCIA'
    },
    {
      Header: 'Fim vigência	',
      accessor: 'FIM_VIGENCIA'
    },
    {
      Header: 'Prêmio',
      accessor: 'PREMIO',
      Cell: ({ row }: { row: { original: { PREMIO: string } } }) => (
        <Text>
          R$ {parseFloat(row.original.PREMIO).toLocaleString('PT-BR')}
        </Text>
      )
    },
    {
      Header: 'Status',
      accessor: 'STATUS'
    }
  ];

  const handleFilter = async () => {
    setLoadingTable(true);

    if (cpfFilter.length > 0 && cpfFilter.length < 11) {
      toast({
        position: 'top',
        description: 'CPF incompleto, favor verificar o preenchimento',
        status: 'warning',
        duration: 9000,
        isClosable: true
      });

      setLoadingTable(false);

      return;
    }

    await getData();

    if (cpfFilter.length > 0) {
      const newTable = data.table.filter((item) =>
        item.CPF.includes(
          cpfFilter.replaceAll('.', '').replace('-', '').replaceAll(/\s/g, '')
        )
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (nameFilter.length > 0) {
      const newTable = data.table.filter((item) =>
        item.NOME.toLowerCase().includes(nameFilter.toLowerCase())
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (productFilter.length > 0) {
      const newTable = data.table.filter((item) =>
        item.PRODUTO.toString()
          .toLowerCase()
          .includes(productFilter.toLowerCase().replaceAll(/\s/g, ''))
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (statusFilter.length > 0) {
      const newTable = data.table.filter((item) =>
        item.STATUS.toLowerCase().includes(
          statusFilter.toLowerCase().replaceAll(/\s/g, '')
        )
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (evFilter.length > 0) {
      const newTable = data.table.filter((item) => item.EV === evFilter);

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    setLoadingTable(false);

    setLoadingTable(false);
  };

  const handleClearFilters = async () => {
    setLoading(true);

    setNameFilter('');
    setCpfFilter('');
    setProductFilter('');
    setStatusFilter('');
    setEvFilter('');

    setBlockedFields(blockedFieldsInitialValue);

    await getData();

    setLoading(false);
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(code).then(() => {
      toast({
        position: 'top',
        description: 'Código copiado!',
        status: 'success',
        duration: 1000,
        isClosable: true
      });
    });
  };

  const getDadosSegundaVia = async ({
    id_contrato,
    num_proposta
  }: {
    id_contrato: number;
    num_proposta: number;
  }): Promise<{
    codigo_qr_code?: string;
    data_vencimento: string;
    link_qr_code?: string;
    codigo_barras_formatado: string;
    valor: string;
  }> => {
    const response = await apiSensedia.get(
      `/gestao-de-carteiras/carteira-vida-individual/contratos/${id_contrato}/segunda-via`,
      {
        headers: {
          'numero-proposta': num_proposta
        }
      }
    );

    return response.data;
  };

  const fetchDetails = async (name: string, cpf: string, policy: string) => {
    const response = await apiSensedia.get(
      `/gestao-de-carteiras/carteira-vida-individual`,
      {
        headers: {
          cpf,
          'tipo-produto': 'VIDA'
        },
        params: {
          policy: policy ?? 0
        },
        timeout: 0
      }
    );
    console.log(response.data.data);
    if (response.data.data) {
      setDetails({
        name: name,
        policy: policy,
        cobertura: response.data.data.cobertura,
        assistencia: response.data.data.assistencia
      });

      setLoadingDetails(false);
    }
  };

  const handleDetails = async (name: string, cpf: string, policy: string) => {
    onOpen();
    setLoadingDetails(true);
    let looping = true;
    while (looping) {
      try {
        await fetchDetails(name, cpf, policy);
        looping = false;
      } catch (e: any) {
        if (e.response.status === 504) {
          await delay(2000);
          continue;
        }
        looping = false;
        if (e.response.status === 401) {
          onClose();
          onOpen2();
        } else {
          const errorObj = e?.toJSON();
          const hasStatus = errorObj?.status || e?.response?.data?.statusCode;
          const hasMessage = errorObj?.message || e?.response?.data?.message;
          toast({
            position: 'top',
            description: (
              <Box>
                <Text>
                  {' '}
                  Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                  minutos e tente fazer login novamente, se persistir, por favor
                  entrar em contato.
                </Text>
                <Text>
                  {hasStatus && (
                    <>
                      <br />
                      <b>Detalhes:</b>
                      <br />
                    </>
                  )}
                  {hasStatus && (
                    <>{errorObj.status ?? e.response.data.statusCode}</>
                  )}
                  {hasStatus && hasMessage && ' - '}
                  {hasMessage && (
                    <>{e.response.data.message ?? errorObj.message}</>
                  )}
                </Text>
              </Box>
            ),
            duration: 15000,
            isClosable: true,
            status: 'error'
          });
        }

        setLoadingDetails(false);
      }
    }
  };

  const getData = async () => {
    setLoading(true);

    let looping = true;

    while (looping) {
      try {
        const response = await apiSensedia.get(
          `/gestao-de-carteiras/carteira-vida-individual`,
          {
            headers: {
              'tipo-produto': 'VIDA'
            },
            timeout: 0
          }
        );

        if (response.data.data) {
          setData({
            table: response.data.data
          });

          setTable(response.data.data);
        }

        looping = false;

        setLoading(false);
      } catch (e: any) {
        if (e.response.status === 504) {
          console.log('ocorreu gateway timeout, tentando novamente');
          await delay(6000);
          continue;
        }
        if (e.response.status === 401) {
          onOpen2();
        } else {
          const errorObj = e?.toJSON();
          const hasStatus = errorObj?.status || e?.response?.data?.statusCode;
          const hasMessage = errorObj?.message || e?.response?.data?.message;
          toast({
            position: 'top',
            description: (
              <Box>
                <Text>
                  {' '}
                  Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                  minutos e tente fazer login novamente, se persistir, por favor
                  entrar em contato.
                </Text>
                <Text>
                  {hasStatus && (
                    <>
                      <br />
                      <b>Detalhes:</b>
                      <br />
                    </>
                  )}
                  {hasStatus && (
                    <>{errorObj.status ?? e.response.data.statusCode}</>
                  )}
                  {hasStatus && hasMessage && ' - '}
                  {hasMessage && (
                    <>{e.response.data.message ?? errorObj.message}</>
                  )}
                </Text>
              </Box>
            ),
            duration: 15000,
            isClosable: true,
            status: 'error'
          });
        }
        looping = false;
        setLoading(false);
      }
    }
  };

  const exportData = (ext: 'csv' | 'xls') => {
    const data = formatDataEfetivado();
    const fileName = `Dados_${new Date()
      .toLocaleString()
      .replaceAll('/', '-')
      .replaceAll(', ', '_')}`;
    const exportType = exportFromJSON.types[ext];

    exportFromJSON({ data, fileName, exportType });
  };

  const formatDataEfetivado = () => {
    if (table) {
      return table.map((item) => {
        return {
          nomeCliente: item.NOME,
          cpfCliente: item.CPF,
          apolice: item.APOLICE,
          produto: item.PRODUTO,
          ev: item.EV,
          inicioVigencia: item?.INICIO_VIGENCIA,
          fimVigencia: item?.FIM_VIGENCIA,
          premiacao: item.PREMIO,
          status: item.STATUS
        };
      });
    }
    return data.table.map((item) => {
      return {
        nomeCliente: item.NOME,
        cpfCliente: item.CPF,
        apolice: item.APOLICE,
        produto: item.PRODUTO,
        ev: item.EV,
        inicioVigencia: item?.INICIO_VIGENCIA,
        fimVigencia: item?.FIM_VIGENCIA,
        premiacao: item.PREMIO,
        status: item.STATUS
      };
    });
  };

  const getEvs = async () => {
    const response = await apiSensedia.get('/parceiros');
    const evs = response.data as any[];

    setEvOptions(evs);
  };

  useEffect(() => {
    getEvs();
    getData();
  }, []);

  useEffect(() => {
    setItemsCount(table.length > 10 ? 10 : table.length);
  }, [table]);

  useEffect(() => {
    (window as any).fieldsRefs = fieldsRefs;

    const entries = Object.entries(blockedFields);
    for (const entry of entries) {
      const element: HTMLInputElement | HTMLSelectElement = fieldsRefs[entry[0]]
        .current.inputElement
        ? fieldsRefs[entry[0]].current.inputElement
        : fieldsRefs[entry[0]].current;

      element.disabled = entry[1];
      element.value = element.disabled ? '' : element.value;
    }

    console.log(entries);
  }, [blockedFields]);

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  });

  return (
    <>
      <Stack p="1.7vw 11.5vw" spacing={23}>
        <Stack spacing={7}>
          <Stack spacing={1}>
            <Link href="/corretor" w="4rem">
              <HStack spacing={0}>
                <ChevronLeftIcon />
                <Text fontSize="1rem" color="#696969" fontWeight="bold">
                  Voltar
                </Text>
              </HStack>
            </Link>
            <Flex justifyContent="space-between" alignItems="center">
              <Text color="#00335E" fontWeight="bold" fontSize="1.2rem">
                Carteira Vida Individual
              </Text>
              <Menu>
                <MenuButton
                  bg="none"
                  variant="outline"
                  border="1px"
                  borderColor="#1B365D"
                  color="#1B365D"
                  fontSize="0.8rem"
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                >
                  Exportar Dados
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={() => exportData('csv')}>
                    Baixar .csv
                  </MenuItem>
                  <MenuItem onClick={() => exportData('xls')}>
                    Baixar .xls
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </Stack>

          <HStack
            bg="#fff"
            wrap="wrap"
            borderRadius="1rem"
            minH="4.3rem"
            spacing={39}
            justify={isWideVersion ? 'flex-start' : 'center'}
            flexDir={{ base: 'column', lg: 'row' }}
            pointerEvents={!loading ? 'all' : 'none'}
            opacity={!loading ? '1' : '0.4'}
          >
            <HStack
              flexDir={{ base: 'column', md: 'column', lg: 'row' }}
              m=".6rem !important"
            >
              <Text fontSize=".8rem" fontWeight="bold" color="#1B365D">
                Filtrar:
              </Text>

              <Input
                ref={fieldsRefs.nome}
                color="#1B365D"
                fontSize=".7rem"
                w="8rem"
                h="2.1rem"
                placeholder="Nome"
                value={nameFilter}
                onChange={(e) => {
                  if (e.target.value.length > 0) {
                    setBlockedFields({
                      cpf: true,
                      ev: true,
                      nome: false,
                      produto: true,
                      situacao: true
                    });
                  } else {
                    resetBlockedValues();
                  }
                  setNameFilter(e.target.value);
                }}
              />

              <Input
                ref={fieldsRefs.cpf}
                as={MaskedInput}
                mask={cpf}
                guide={false}
                color="#1B365D"
                fontSize=".7rem"
                w="9.3rem"
                h="2.1rem"
                placeholder="CPF"
                value={cpfFilter}
                onChange={(e) => {
                  if (e.target.value.length > 0) {
                    setBlockedFields({
                      cpf: false,
                      ev: true,
                      nome: true,
                      produto: true,
                      situacao: true
                    });
                  } else {
                    resetBlockedValues();
                  }
                  setCpfFilter(
                    e.target.value.replaceAll('.', '').replace('-', '')
                  );
                }}
              />
              <Input
                ref={fieldsRefs.produto}
                color="#1B365D"
                fontSize=".7rem"
                w="8rem"
                h="2.1rem"
                placeholder="Produto"
                value={productFilter}
                onChange={(e) => {
                  if (e.target.value.length > 0) {
                    setBlockedFields({
                      cpf: true,
                      ev: true,
                      nome: true,
                      produto: false,
                      situacao: true
                    });
                  } else {
                    resetBlockedValues();
                  }
                  setProductFilter(e.target.value);
                }}
              />
              <Select
                ref={fieldsRefs.situacao}
                color="#1B365D"
                fontSize=".7rem"
                w="8rem"
                h="2.1rem"
                value={statusFilter}
                onChange={(e) => {
                  if (e.target.value.length > 0) {
                    setBlockedFields({
                      cpf: true,
                      ev: true,
                      nome: true,
                      produto: true,
                      situacao: false
                    });
                  } else {
                    resetBlockedValues();
                  }
                  setStatusFilter(e.target.value);
                }}
              >
                <option value="">Situação</option>
                <option value="Aceita">Aceita</option>
                <option value="Ativa">Ativa</option>
                <option value="Cancelada">Cancelada</option>
                <option value="Em analise">Em Analise</option>
                <option value="Em digitação">Em digitação</option>
                <option value="Em qualidade">Em qualidade</option>
                <option value="Reabilitado">Reabilitado</option>
                <option value="Recusada">Recusada</option>
                <option value="Suspenso">Suspenso</option>
              </Select>
              <Select
                ref={fieldsRefs.ev}
                color="#1B365D"
                fontSize=".7rem"
                w="8rem"
                h="2.1rem"
                value={evFilter}
                onChange={(e) => {
                  if (e.target.value.length > 0) {
                    setBlockedFields({
                      cpf: true,
                      ev: false,
                      nome: true,
                      produto: true,
                      situacao: true
                    });
                  } else {
                    resetBlockedValues();
                  }
                  setEvFilter(e.target.value);
                }}
              >
                <option value="">EV</option>

                {evOptions.map((el) => (
                  <option key={el.cod_estr_venda} value={el.cod_estr_venda}>
                    {`${el.cod_estr_venda} - ${el.nome}`}
                  </option>
                ))}
              </Select>
            </HStack>

            <Button
              bg="#FA6B25"
              color="#fff"
              fontSize=".7rem"
              w="5.5rem"
              h="2.1rem"
              isLoading={loading}
              onClick={handleFilter}
              m="0 !important"
              _hover={{
                opacity: '.9'
              }}
            >
              Filtrar
            </Button>
            <Button
              bg="#ACACAC"
              color="#fff"
              fontSize=".7rem"
              w="5.5rem"
              h="2.1rem"
              onClick={handleClearFilters}
              m=".3rem !important"
              _hover={{
                opacity: '.9'
              }}
            >
              Limpar Filtros
            </Button>
          </HStack>
        </Stack>

        {loading ? (
          <Flex
            w="100%"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Spinner />
            <Text fontSize="10px">
              Por favor, aguarde. A sua primeira consulta pode demorar um pouco.
            </Text>
          </Flex>
        ) : (
          <Fade in={!loading}>
            <Stack
              bg="#fff"
              color="#00335E"
              borderRadius="1rem"
              p="1.4rem 1.1rem .8rem"
            >
              {loadingTable ? (
                <Flex w="100%" justify="center">
                  <Spinner />
                </Flex>
              ) : (
                <InteractiveTable
                  sort="NOME"
                  columns={columns}
                  data={table}
                  itemsCount={itemsCount}
                />
              )}
            </Stack>
            <Flex
              w="100%"
              justify="flex-end"
              fontSize=".9rem"
              align="center"
              mt="2.1rem"
            >
              <Flex
                w={{ base: '100%', lg: '60%' }}
                justify={{ base: 'center', lg: 'space-between' }}
                flexDir={{ base: 'column', lg: 'row' }}
              >
                {!loadingTable && (
                  <>
                    <Flex
                      align="center"
                      cursor="pointer"
                      justify="center"
                      onClick={() => {
                        setItemsCount(
                          itemsToShow + itemsCount > table.length
                            ? table.length
                            : itemsToShow + itemsCount
                        );
                      }}
                    >
                      <HiPlusCircle size={26} color="#00335E" />
                      <Text>
                        Mais itens (exibindo {itemsCount}/{table.length})
                      </Text>
                    </Flex>
                    <Box>
                      <Select
                        border="1px solid #00335E !important"
                        borderRadius="1rem !important"
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                          setItemsToShow(parseInt(e.target.value))
                        }
                      >
                        <option value={5}>exibir mais 5 por vez</option>
                        <option value={10}>exibir mais 10 por vez</option>
                        <option value={20}>exibir mais 20 por vez</option>
                        <option value={40}>exibir mais 40 por vez</option>
                      </Select>
                    </Box>
                  </>
                )}
              </Flex>
            </Flex>
          </Fade>
        )}

        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent minW="80vw" borderRadius="1rem" pt="0">
            <ModalHeader color="#1C375C">Dados adicionais</ModalHeader>
            <ModalCloseButton />

            {loadingDetails ? (
              <Flex w="100%" justify="center" align="center" h="10rem">
                <Spinner />
              </Flex>
            ) : (
              <>
                {' '}
                <HStack
                  bg="#00335E"
                  color="#fff"
                  w="100%"
                  h="2.5rem"
                  mb="0 !important"
                  p="0 1.75rem"
                >
                  <Text fontSize="0.93rem" fontWeight="bold">
                    Cliente: {details.name} / Apólice: {details.policy}
                  </Text>
                </HStack>
                <ModalBody pt="0">
                  <TableContainer display="flex">
                    <Table size="sm" variant="striped" h="100%">
                      <Thead h="3.25rem">
                        <Tr>
                          <Th
                            fontSize=".9rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            Cobertura
                          </Th>
                          <Th
                            fontSize=".9rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            Valor Prêmio
                          </Th>
                          <Th
                            fontSize=".9rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            Capital contratado
                          </Th>
                        </Tr>
                      </Thead>

                      <Tbody>
                        {details.cobertura.map((row) => (
                          <Tr
                            key={
                              row.COBERTURA +
                              row.VALOR_PREMIO +
                              row.CAPITAL_CONTRATADO
                            }
                          >
                            <Td>{row.COBERTURA}</Td>
                            <Td>
                              {row.VALOR_PREMIO.toLocaleString() === '0'
                                ? '-'
                                : `R$  ${row.VALOR_PREMIO.toLocaleString()}`}
                            </Td>
                            <Td>
                              {row.CAPITAL_CONTRATADO.toLocaleString() === '0'
                                ? '-'
                                : `R$ ${row.CAPITAL_CONTRATADO.toLocaleString()}`}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <Divider
                      mt="0"
                      orientation="vertical"
                      borderRight="2px solid #1C375C"
                      h="auto"
                    />
                    <Table size="sm" variant="striped" h="100%">
                      <Thead h="3.25rem">
                        <Tr>
                          <Th
                            fontSize=".9rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            Assistência
                          </Th>
                          <Th
                            fontSize=".9rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            Valor Prêmio
                          </Th>
                          <Th
                            fontSize=".9rem"
                            color="#1C375C"
                            textTransform="none"
                            w="2rem"
                          >
                            Capital contratado
                          </Th>
                        </Tr>
                      </Thead>

                      <Tbody>
                        {details.assistencia.map((row) => (
                          <Tr
                            key={
                              row.ASSISTENCIA +
                              row.VALOR_PREMIO +
                              row.CAPITAL_CONTRATADO
                            }
                          >
                            <Td>{row.ASSISTENCIA}</Td>
                            <Td>
                              {row.VALOR_PREMIO.toLocaleString() === '0'
                                ? '-'
                                : `R$  ${row.VALOR_PREMIO.toLocaleString()}`}
                            </Td>
                            <Td>
                              {row.CAPITAL_CONTRATADO.toLocaleString() === '0'
                                ? '-'
                                : `R$ ${row.CAPITAL_CONTRATADO.toLocaleString()}`}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </ModalBody>
              </>
            )}
            <Divider mt="1rem" />
            <ModalFooter justifyContent="center"></ModalFooter>
          </ModalContent>
        </Modal>

        <Modal closeOnOverlayClick={false} isOpen={isOpen2} onClose={onClose2}>
          <ModalOverlay />
          <ModalContent textAlign="center">
            <ModalHeader>Atenção!</ModalHeader>
            <ModalBody>
              <Text>Ops, sua sessão expirou.</Text>
              <Text>
                Por favor, faça novamente o login no Portal do Corretor.
              </Text>
            </ModalBody>

            <ModalFooter justifyContent="center">
              <Link href={process.env.REACT_APP_PORTAL_URL}>
                <Button bg="#FA6B25" color="#fff" colorScheme="orange">
                  Voltar
                </Button>
              </Link>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Stack>
      <Modal
        onClose={() => {
          onModalSegundaViaClose();
          setModalSegundaViaContent({
            codigo_produto: 0,
            nome_produto: '',
            num_proposta: 0,
            codigo_pix: null,
            data_vencimento: null,
            qr_code_url: null,
            valor: null
          });
        }}
        isOpen={isModalSegundaViaOpen}
      >
        <ModalOverlay />
        <ModalContent maxWidth="488px" width="95%" padding="32px">
          <VStack alignItems="flex-start" width="100%">
            <Box className="dados-proposta">
              <Text color="#FF5000" fontSize="0.875rem" fontWeight="700">
                Nº {modalSegundaViaContent.num_proposta}
              </Text>
              <Text
                color="rgb(50, 50, 50)"
                textTransform="uppercase"
                fontSize="1.5rem"
                width="80%"
              >
                {modalSegundaViaContent.codigo_produto}{' '}
                {modalSegundaViaContent.nome_produto}
              </Text>
            </Box>
            <Box
              as="div"
              height="1px"
              width="100%"
              backgroundColor="rgb(210, 210, 210)"
              margin="16px 0 !important"
            ></Box>
            <HStack
              justifyContent="space-between"
              width="100%"
              margin="0 !important"
            >
              <Box>
                <Text
                  color="rgb(130, 130, 130)"
                  fontSize="0.875rem"
                  fontWeight="700"
                  lineHeight="24px"
                >
                  Valor da parcela
                </Text>
                <Text
                  color="rgb(90, 90, 90)"
                  fontSize="1.5rem"
                  fontWeight="700"
                  lineHeight="2rem"
                >
                  R$ {modalSegundaViaContent.valor}
                </Text>
              </Box>
              <Box>
                <Text
                  color="rgb(130, 130, 130)"
                  fontSize="0.875rem"
                  fontWeight="700"
                  lineHeight="24px"
                  textAlign="right"
                >
                  Vencimento
                </Text>
                <Text
                  fontSize="1.25rem"
                  color="rgb(50, 50, 50)"
                  textAlign="right"
                >
                  {formatDate(modalSegundaViaContent.data_vencimento)}
                </Text>
              </Box>
            </HStack>
            <Box
              as="div"
              height="1px"
              width="100%"
              backgroundColor="rgb(210, 210, 210)"
              margin="16px 0 !important"
            ></Box>
            <VStack
              className="dados-pagamento"
              width="100%"
              margin="0 !important"
            >
              {modalSegundaViaContent.codigo_pix ? (
                <Text
                  color="#323232"
                  fontWeight="bold"
                  lineHeight="24px"
                  width="100%"
                >
                  Seu cliente pode efetuar o pagamento através do{' '}
                  <Box as="span" color="rgb(255, 80, 0)">
                    QRCode
                  </Box>
                </Text>
              ) : (
                <Text
                  color="#323232"
                  fontWeight="bold"
                  lineHeight="24px"
                  width="100%"
                >
                  Seu cliente pode efetuar o pagamento através da numeração do{' '}
                  <Box as="span" color="rgb(255, 80, 0)">
                    Código de Barras
                  </Box>{' '}
                  abaixo.
                </Text>
              )}

              <HStack marginTop="14px !important" width="100%">
                <ClockIcon />
                {modalSegundaViaContent.codigo_pix ? (
                  <Text fontSize="0.75rem" lineHeight="24px">
                    O prazo para compensação bancária é de até 8 horas.
                  </Text>
                ) : (
                  <Text fontSize="0.75rem" lineHeight="24px">
                    Atenção! O registro bancário do boleto ocorre em até 2 horas
                    úteis.
                    <br />
                    <strong>
                      Aguarde esse período para realizar o pagamento.
                    </strong>
                  </Text>
                )}
              </HStack>
              {modalSegundaViaContent.codigo_pix ? (
                <Image
                  width="168px"
                  alt="QRCode Pix"
                  src={modalSegundaViaContent.qr_code_url}
                  margin="0 !important"
                />
              ) : (
                <>
                  <Box
                    width="100%"
                    border="1px solid rgb(255, 80, 0)"
                    padding="16px"
                    margin="22px 0 16px 0 !important"
                    borderRadius="4px"
                    fontSize="0.75rem"
                    fontWeight="400"
                    textAlign="center"
                    lineHeight="24px"
                    wordBreak="break-all"
                  >
                    {modalSegundaViaContent.codigo_barras_formatado}
                  </Box>

                  <Button
                    background="transparent"
                    color="rgb(255, 80, 0)"
                    _hover={{
                      backgroundColor: 'transparent',
                      color: 'rgb(0, 30, 100) !important'
                    }}
                    _focus={{
                      outline: '0',
                      background: 'transparent !important'
                    }}
                  >
                    <HStack gap="4px">
                      <Box
                        as="span"
                        marginRight="8px"
                        onClick={() => {
                          copyCode(
                            modalSegundaViaContent.codigo_barras_formatado
                          );
                        }}
                      >
                        <BarCodeIcon />
                      </Box>
                      <Text
                        textTransform="uppercase"
                        fontSize="0.75rem"
                        margin="0 !important"
                        textDecoration="underline"
                        fontWeight="bold"
                        lineHeight="14px"
                        onClick={() => {
                          copyCode(
                            modalSegundaViaContent.codigo_barras_formatado
                          );
                        }}
                      >
                        Copiar Código
                      </Text>
                    </HStack>
                  </Button>
                </>
              )}
              <Box
                as="div"
                height="1px"
                width="100%"
                backgroundColor="rgb(210, 210, 210)"
                margin="16px 0 !important"
              ></Box>
              {modalSegundaViaContent.codigo_pix ? (
                <>
                  <Text
                    color="#323232"
                    fontWeight="bold"
                    lineHeight="0.8rem"
                    width="100%"
                  >
                    ou{' '}
                    <Box as="span" color="rgb(255, 80, 0)">
                      copie e cole
                    </Box>{' '}
                    o código abaixo:
                  </Text>
                  <Box
                    width="100%"
                    border="1px solid rgb(255, 80, 0)"
                    padding="16px"
                    margin="22px 0 16px 0 !important"
                    borderRadius="4px"
                    fontSize="0.75rem"
                    fontWeight="400"
                    textAlign="center"
                    lineHeight="24px"
                    wordBreak="break-all"
                  >
                    {modalSegundaViaContent.codigo_pix}
                  </Box>

                  <Button
                    background="transparent"
                    color="rgb(255, 80, 0)"
                    _hover={{
                      backgroundColor: 'transparent',
                      color: 'rgb(0, 30, 100) !important'
                    }}
                    _focus={{
                      outline: '0',
                      background: 'transparent !important'
                    }}
                  >
                    <HStack gap="4px">
                      <Box
                        as="span"
                        marginRight="8px"
                        onClick={() => {
                          copyCode(modalSegundaViaContent.codigo_pix);
                        }}
                      >
                        <BarCodeIcon />
                      </Box>
                      <Text
                        textTransform="uppercase"
                        fontSize="0.75rem"
                        margin="0 !important"
                        textDecoration="underline"
                        fontWeight="bold"
                        lineHeight="14px"
                        onClick={() => {
                          copyCode(modalSegundaViaContent.codigo_pix);
                        }}
                      >
                        Copiar Código
                      </Text>
                    </HStack>
                  </Button>
                </>
              ) : (
                <Box
                  width="100%"
                  backgroundColor="rgb(246, 231, 177)"
                  padding="16px"
                  borderRadius="4px"
                >
                  <HStack gap="16px">
                    <WarningIcon />{' '}
                    <Text fontSize="14px">
                      Em caso de atraso de pagamento,{' '}
                      <strong>
                        seu boleto tem validade até 60 dias após o vencimento.
                      </strong>
                    </Text>
                  </HStack>
                </Box>
              )}
            </VStack>
          </VStack>
        </ModalContent>
      </Modal>
    </>
  );
};
